export default "__VITE_ASSET__Djdpk8tN__"